import { isEmptyTile } from '@/utils';
import styles from './Tile.module.scss';

interface ITileProps {
  label: string;
  value: string;
  variant?: 'normal' | 'large' | 'extra' | 'xxl' | 'xxxl';
  className?: string;
  tileStyle?: string;
}

function Tile({ label, value, variant = 'normal', className = '', tileStyle = '' }: ITileProps) {
  let tileSize = variant;

  // Check for content size to auto set a bigger tile to avoid text overflow
  if (value.length > 50) {
    tileSize = 'xxxl';
  } else if (value.length > 40) {
    tileSize = 'xxl';
  } else if (value.length > 10) {
    tileSize = 'large';
  }

  return (
    <div className={`${styles.tile} ${styles[tileSize]} ${className}`}>
      <div className={styles.tileLabel}>{label}</div>
      <div className={`${styles.tileValue} ${tileStyle} ${isEmptyTile(value) ? styles.tileEmpty : ''}`}>{value}</div>
    </div>
  );
}

export default Tile;
